import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import './Levelintro.css';

const LevelIntro = ({ leftImage, rightImage, dialogues, onFinish }) => {
  const [phase, setPhase] = useState('first');
  const [firstText, setFirstText] = useState('');
  const [secondText, setSecondText] = useState('');
  const [firstDone, setFirstDone] = useState(false);

  const overlayRef = useRef();
  const leftImgRef = useRef();
  const rightImgRef = useRef();
  const firstBoxRef = useRef();
  const secondBoxRef = useRef();
  const typingRef = useRef(null);

  useEffect(() => {
    gsap.set(overlayRef.current, { opacity: 0 });
    gsap.set(leftImgRef.current, { opacity: 0, x: -60, scale: 0.85 });
    gsap.set(rightImgRef.current, { opacity: 0, x: 60, scale: 0.85 });
    gsap.set(firstBoxRef.current, { opacity: 0, scale: 0.88, y: 16 });
    gsap.set(secondBoxRef.current, { opacity: 0, scale: 0.88, y: 16 });

    const tl = gsap.timeline();
    tl
      .to(overlayRef.current, { opacity: 1, duration: 0.9, ease: 'power2.out' })
      .to(leftImgRef.current, { opacity: 1, x: 0, scale: 1, duration: 0.9, ease: 'back.out(1.8)' }, '-=0.3')
      .to(firstBoxRef.current, { opacity: 1, scale: 1, y: 0, duration: 0.8, ease: 'back.out(1.6)' }, '-=0.4')
      .call(() => typeText(dialogues[0].text, setFirstText, () => {
        setFirstDone(true);
        startSecondDialogue();
      }));

    return () => { if (typingRef.current) clearTimeout(typingRef.current); };
  }, []);

  const typeText = (text, setter, onDone, index = 0) => {
    if (index >= text.length) {
      if (onDone) onDone();
      return;
    }
    setter(text.slice(0, index + 1));
    typingRef.current = setTimeout(() => typeText(text, setter, onDone, index + 1), 36);
  };

  const startSecondDialogue = () => {
    setPhase('second');
    gsap.to(rightImgRef.current, {
      opacity: 1, x: 0, scale: 1,
      duration: 0.9, ease: 'back.out(1.8)',
      onComplete: () => {
        gsap.to(secondBoxRef.current, {
          opacity: 1, scale: 1, y: 0,
          duration: 0.8, ease: 'back.out(1.6)',
          onComplete: () => {
            typeText(dialogues[1].text, setSecondText, () => {
              setTimeout(() => {
                gsap.to(
                  [firstBoxRef.current, secondBoxRef.current, leftImgRef.current, rightImgRef.current, overlayRef.current],
                  {
                    opacity: 0, y: 20,
                    duration: 0.6, ease: 'power2.in',
                    stagger: 0.08,
                    onComplete: () => setTimeout(() => onFinish(), 300),
                  }
                );
              }, 2000);
            });
          },
        });
      },
    });
  };

  return (
    <div className="level-intro-overlay" ref={overlayRef}>
      <div className="intro-left-img" ref={leftImgRef}>
        <img src={leftImage} alt="left character" />
      </div>

      <div className="intro-dialogue-box intro-dialogue-first" ref={firstBoxRef}>
        <div className="intro-dialogue-inner">
          <p className="intro-dialogue-text">
            {firstText}
            {!firstDone && <span className="intro-cursor">|</span>}
          </p>
        </div>
        <div className="intro-hinge">
          <div className="intro-hinge-bar" />
          <div className="intro-hinge-bar" />
          <div className="intro-hinge-bar" />
        </div>
      </div>

      <div className="intro-right-img" ref={rightImgRef}>
        <img src={rightImage} alt="right character" />
      </div>

      <div className="intro-dialogue-box intro-dialogue-second" ref={secondBoxRef}>
        <div className="intro-dialogue-inner">
          <p className="intro-dialogue-text">
            {secondText}
            {phase === 'second' && secondText.length < dialogues[1].text.length && (
              <span className="intro-cursor">|</span>
            )}
          </p>
        </div>
        <div className="intro-hinge intro-hinge-right">
          <div className="intro-hinge-bar" />
          <div className="intro-hinge-bar" />
          <div className="intro-hinge-bar" />
        </div>
      </div>
    </div>
  );
};

export default LevelIntro;